/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: TJ Felman
 * @ Modified time: 2022-03-21 13:24:17
 * @ Description: Dialog containing ways too get more bonus properties by sharing links
 */

import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Grid,
  Button,
  Card,
  Dialog,
  Fab,
  InputAdornment,
  TextField,
  Box,
} from '@mui/material'

import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import { CopyToClipboard } from 'react-copy-to-clipboard'

// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'

import { enqueueSnackbar } from 'notistack'
import { useMutation } from '@apollo/client/react'
import { CREATE_SESSION } from '@/housefolios-components/LaunchpadComponents/mutations'
import withSession from '@/housefolios-components/Session/withSession'
import { ON_DARK } from '@/theme/skinSx'

function BonusPropertiesComponent(props) {
  const hostname = import.meta.env.VITE_HOSTNAME

  const orgLink =
    hostname === 'localhost'
      ? 'http://localhost:3000/createAccount' +
        '/?org=' +
        props.session.me.activeOrg._id
      : hostname === 'dev-admin.housefolios.com'
        ? 'https://dev-admin.housefolios.com/createAccount' +
          '/?org=' +
          props.session.me.activeOrg._id
        : 'https://app.housefolios.com/createAccount/?org=' +
          props.session.me.activeOrg._id

  const encodedOrgLink = encodeURIComponent(
    'https://app.housefolios.com/createAccount?org=' +
      props.session.me.activeOrg._id,
  )

  const { launchpad, sidebarMenu, upsell } = props

  const [modal1, seModal1] = useState(false)

  const toggle1 = () => seModal1(!modal1)

  const [createBillingPortalSession] = useMutation(CREATE_SESSION)

  const changePlan = async () => {
    var session = await createBillingPortalSession()

    window.open(
      session.data.createBillingPortalSession.url,
      '_self',
      '',
    )
  }

  return (
    <>
      {launchpad && (
        <Button onClick={toggle1} fullWidth sx={[{
          backgroundColor: "rgba(79, 80, 98, 0.15)",
          color: "#4f5062",
          borderColor: "transparent",
          "&:hover, &.active": { backgroundColor: "#4f5062", color: "#fff" },
          "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
          "html[data-color-mode=\"dark\"] &": { background: "rgba(255, 255, 255, 0.08) !important", color: "rgba(255, 255, 255, 0.92) !important" },
          transition: "all 0.2s ease-in-out !important",
          transform: "scale(1) !important",
          position: "relative",
          zIndex: "0",
          "&:hover": { transform: "scale(1.08)", zIndex: 3 },
          fontWeight: 700,
          textTransform: "uppercase",
        }, { fontSize: "0.875rem !important" }]}>
          Get Bonus Properties
        </Button>
      )}
      {sidebarMenu && (
        <Button
          onClick={toggle1}
          size="small"
          data-hf="btn-userbox"
          fullWidth={true}
        >
          Get More Properties
        </Button>
      )}
      {upsell && (
        <Button
          onClick={toggle1}
          variant="contained"
          style={{ backgroundColor: '#f58747', color: 'white' }}
        >
          Get Bonus Properties
        </Button>
      )}
      <Dialog
        scroll="body"
        maxWidth="lg"
        open={modal1}
        onClose={toggle1}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '0.65rem',
              overflow: 'hidden',
              [ON_DARK]: {
                backgroundColor: '#1e1e1e !important',
                color: 'rgba(255, 255, 255, 0.87)',
              },
            },
          },
        }}
      >
        <Grid container spacing={0}>
          <Grid size={12} container>
            <Grid size={{ xs: 12, md: 5 }}>
              <Box
                sx={{
                  height: '100%',
                  minHeight: { xs: 240, md: '100%' },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  backgroundColor: '#253152',
                  color: '#fff',
                  p: '3rem',
                  textAlign: { xs: 'center', xl: 'left' },
                }}
              >
                <Box
                  component="h1"
                  sx={[
                    { my: '1rem', fontWeight: 700, color: '#fff' },
                    { fontSize: "1.7rem", fontWeight: "300", lineHeight: "1.2" },
                  ]}
                >
                  Upgrade your plan today
                </Box>
                <Box
                  component="p"
                  sx={[
                    { mb: 0, color: 'rgba(255, 255, 255, 0.7)' },
                    { fontSize: "1.15rem !important" },
                  ]}
                >
                  Upgrade your plan and get more properties every
                  month!
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    target="_blank"
                    color="primary"
                    style={{ color: 'white' }}
                    onClick={
                      isEmpty(
                        props.session.me.activeOrg.subscriptions,
                      )
                        ? props.toggleSubscribe
                        : changePlan
                    }
                    sx={{
                      fontWeight: 700,
                      px: '1.5rem',
                      my: '1rem',
                      width: '100%',
                      borderRadius: '0.65rem',
                    }}
                  >
                    Upgrade Plan
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 7 }}>
              <Box sx={{
                "@media (min-width: 1440px)": { mt: 0 },
                mt: "1.5rem",
              }}>
                <Box sx={{ m: '1.5rem' }}>
                  <Box
                    component="h1"
                    sx={[
                      { my: '1rem', fontWeight: 700 },
                      { fontSize: '1.7rem', fontWeight: '300', lineHeight: '1.2' },
                      {
                        [ON_DARK]: {
                          color: 'rgba(255, 255, 255, 0.87) !important',
                        },
                      },
                    ]}
                  >
                    Give 10, Get 10
                  </Box>
                  <Box
                    component="p"
                    sx={[
                      { mb: 0, color: 'rgba(7, 9, 25, 0.5)' },
                      { fontSize: '1rem !important' },
                      {
                        [ON_DARK]: {
                          color: 'rgba(255, 255, 255, 0.68) !important',
                        },
                      },
                    ]}
                  >
                    Share your link, whenever somebody signs up, both
                    you and them will get 10 BONUS properties!
                  </Box>
                </Box>
                <Card
                  sx={{
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    p: '1.5rem',
                    border: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: 'block',
                      p: '1rem',
                      pt: 0,
                      borderRadius: '0.65rem',
                      backgroundColor: '#f4f5fd',
                      [ON_DARK]: {
                        backgroundColor: '#2a2a2a !important',
                        color: 'rgba(255, 255, 255, 0.87)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        color: '#a6a6b9',
                        textAlign: 'center',
                        mb: '1rem',
                        [ON_DARK]: {
                          color: 'rgba(255, 255, 255, 0.68) !important',
                        },
                      }}
                    >
                      <small>Click below to share!</small>
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                      <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        sx={{
                          justifyContent: 'center',
                        }}
                      >
                        <Grid>
                          <Button
                           
                            target="_blank"
                            href={
                              'https://www.facebook.com/sharer/sharer.php?u=' +
                              encodedOrgLink
                            }
                            sx={{
                              boxShadow: "0 0.25rem 0.55rem rgba(59, 89, 153, 0.35)",
                              color: "#fff",
                              backgroundColor: "#3b5999",
                              backgroundImage: "none",
                              borderColor: "#3b5999",
                              "&:not(:disabled):hover": { backgroundColor: "#3b5999", color: "#fff" },
                              "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#344e87" },
                              "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(59, 89, 153, 0.4), 0 0.0625rem 0.385rem rgba(59, 89, 153, 0.54)" },
                              "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(59, 89, 153, 0.4), 0 0.0625rem 0.385rem rgba(59, 89, 153, 0.54)" },
                              mr: "0.5rem",
                            }}
                          >
                            <span style={{ display: "inline-flex" }}>
                              <FontAwesomeIcon
                                icon={['fab', 'facebook']}
                              />
                            </span>
                            <Box component="span" sx={{
                              display: "inline-block",
                              "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                              "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                            }}>
                              Facebook
                            </Box>
                          </Button>
                        </Grid>
                        <Grid>
                          <Button
                           
                            href={
                              'https://twitter.com/intent/tweet?text=' +
                              encodedOrgLink +
                              'I%27ve%20been%20using%20Housefolios%20real%20estate%20software%20to%20analyze%20investment%20properties.%20Using%20this%20link%20will%20let%20you%20analyze%2010%20properties%20(and%20give%20me%2010%20more%20properties!)'
                            }
                            target="_blank"
                            sx={{
                              boxShadow: "0 0.25rem 0.55rem rgba(29, 161, 242, 0.35)",
                              color: "#fff",
                              backgroundColor: "#1da1f2",
                              backgroundImage: "none",
                              borderColor: "#1da1f2",
                              "&:not(:disabled):hover": { backgroundColor: "#1da1f2", color: "#fff" },
                              "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0d95e8" },
                              "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(29, 161, 242, 0.4), 0 0.0625rem 0.385rem rgba(29, 161, 242, 0.54)" },
                              "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(29, 161, 242, 0.4), 0 0.0625rem 0.385rem rgba(29, 161, 242, 0.54)" },
                              ml: "0.5rem",
                            }}
                          >
                            <span style={{ display: "inline-flex" }}>
                              <FontAwesomeIcon
                                icon={['fab', 'twitter']}
                              />
                            </span>
                            <Box component="span" sx={{
                              display: "inline-block",
                              "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                              "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                            }}>
                              Twitter
                            </Box>
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  <div>
                    <Box
                      sx={{
                        textAlign: 'center',
                        color: '#a6a6b9',
                        my: '1rem',
                        [ON_DARK]: {
                          color: 'rgba(255, 255, 255, 0.68) !important',
                        },
                      }}
                    >
                      <small>Or use your unique link below!</small>
                    </Box>
                    <Box sx={{ mb: '1rem' }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        id="textfield-email"
                        value={orgLink}
                        slotProps={{
                          input: {
                            endAdornment: (
                              <InputAdornment position="end">
                                <CopyToClipboard
                                  text={orgLink}
                                  onCopy={() =>
                                    enqueueSnackbar(
                                      `Copied to Clipboard`,
                                      {
                                        variant: 'success',
                                        autoHideDuration: 3000,
                                      },
                                    )
                                  }
                                >
                                  <Fab size="small" color="primary">
                                    <FileCopyOutlinedIcon
                                      style={{ color: 'white' }}
                                    />
                                  </Fab>
                                </CopyToClipboard>
                              </InputAdornment>
                            ),
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ color: 'white' }}
                        onClick={toggle1}

                        sx={{
                          fontWeight: 700,
                          px: '1.5rem',
                          my: '1rem',
                        }}
                      >
                        Close
                      </Button>
                    </Box>
                  </div>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

export default withSession(BonusPropertiesComponent)
